import React, { ComponentType, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Loader } from '@mantine/core';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { formatNumberDecimals, numberSeparator } from '@/utils/numberSeparator';
import { useStore } from '@/zustand/store/store';
import styles from './EarlyAccessTelegram.module.scss';
import { CustomModal } from '@/components/Molecules';
import { Button, Typography } from '@/components/Atoms';
import Input from '@/components/Common/Input';
import api from '@/api/services/achievements';
// import jwt_decode from 'jwt-decode';

type IProps = {
  type?: 'early' | 'verify';
};

// eslint-disable-next-line arrow-body-style
const EarlyAccessTelegram = ({ type = 'verify' }: IProps) => {
  const { data: session, update } = useSession();
  const [value, setValue] = useState('');
  const { setEarlyAccessModal, earlyAccessModal } = useStore();
  const [loading, setLoading] = useState(false); // Loading state

  const onCloseModal = () => {
    setEarlyAccessModal(false);
  };

  const handleSubmit = async () => {
    if (!value) {
      toast.error('Please enter your Telegram ID', {
        position: 'bottom-center',
        autoClose: 4000,
        closeOnClick: true,
        theme: 'dark',
      });
      return;
    }
    setLoading(true); // Set loading state to true

    try {
      await api.verifyOtherAccount('telegram', { user_id: `${value}` }, 'command_center');
      setEarlyAccessModal(false);
      let text = 'Your Telegram ID has been successfully registered. You now have access to the App.';
      if (type === 'verify') {
        text = 'Your Telegram username has been successfully registered.';
      }
      toast.success(text, {
        position: 'bottom-center',
        autoClose: 4000,
        closeOnClick: true,
        theme: 'dark',
      });
    } catch (error) {
      console.error('Error verifying account:', error);
      toast.error('An error occurred while verifying your Telegram ID. Please try again.', {
        position: 'bottom-center',
        autoClose: 4000,
        closeOnClick: true,
        theme: 'dark',
      });
    } finally {
      setLoading(false); // Set loading state back to false
    }
  };

  let title = 'Early Access';
  let desc = 'Please enter your Telegram ID to get whitelist access.';
  if (type === 'verify') {
    title = 'Check ID';
    desc = 'Please enter your Telegram ID.';
  }

  return (
    <CustomModal showCloseIcon={true} closeOnClickOutside={true} visible={earlyAccessModal} centered onClose={onCloseModal}>
      <div className={styles.container}>
        <div className={styles.shadowContainer}>
          <div className={`${styles.shadow}`}></div>
        </div>
        <div>
          <Typography isBold Component='div' className={styles.title}>
            {title}
          </Typography>
        </div>
        <div className='w-full flex justify-center items-center'>
          <div className='z-[11] w-full lg:w-[550px] mt-[16px] md:mt-[34px] flex flex-col'>
            <div className='mb-2 lg:mb-4'>
              <Typography Component='div' size='s18ToS14' className='text-white'>
                {desc}
              </Typography>
            </div>

            <Typography className='text-base text-[#7D7E82]'>Telegram ID:</Typography>
            <Input
              placeholder='@TelegramID'
              name={'telegram_id'}
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              type='text'
              required
              className='border-2 !border-[#595959] text-white'
            />
            <div className='w-full flex justify-center items-center mt-[20px] md:mt-[48px]'>
              <Button
                className='w-[70%] md:w-[80%] rounded-lg border border-[#29DF41] bg-[#29df412a] h-[46px] md:h-[54px] font-bold text-white'
                onClick={handleSubmit}
                disabled={loading} // Disable the button while loading
              >
                {loading ? (
                  <Loader color='white' size='sm' /> // Show loader while processing
                ) : (
                  <Typography size='s22ToS14'>Send</Typography>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default EarlyAccessTelegram;
